import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InviteStatus from "../../../../enums/InviteStatus";

interface IInviteStatusBadgeProps {
    status: InviteStatus;
}

const InviteStatusBadge = (props: IInviteStatusBadgeProps) => {
    const { t } = useTranslation();

    switch (props.status) {
        case InviteStatus.Queued:
            return (
                <Badge bg="secondary">
                    {t("it.invite.history.status.queued")}
                </Badge>
            );

        case InviteStatus.Processing:
            return (
                <Badge bg="warning" text="dark">
                    {t("it.invite.history.status.processing")}
                </Badge>
            );

        case InviteStatus.Successful:
            return (
                <Badge bg="success">
                    {t("it.invite.history.status.successful")}
                </Badge>
            );

        case InviteStatus.Failed:
            return (
                <Badge bg="danger">
                    {t("it.invite.history.status.failed")}
                </Badge>
            );
    }
};

export default InviteStatusBadge;